// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type AuswertungAufgabe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetAuswertungAufgabe(): (
  aufgabeId: string,
  kontaktaufnahmeId: string
) => Promise<AuswertungAufgabe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, kontaktaufnahmeId) =>
      (await getAPI()).auswertungAufgabenUebersicht.getAuswertungAufgabe({
        aufgabeId,
        kontaktaufnahmeId,
      }),
    [getAPI]
  );
}
